import * as actionTypes from '../constants/actionTypes';
export function loadCodeStart(lang) {
    return {
        type: actionTypes.LOAD_CODE_START,
        lang: lang,
    };
}
export function loadCodeDone(lang, code) {
    return {
        type: actionTypes.LOAD_CODE_DONE,
        lang: lang,
        code: code,
    };
}
export function loadCodeFailed(lang, error) {
    return {
        type: actionTypes.LOAD_CODE_FAILED,
        lang: lang,
        error: error,
    };
}
export function setCurrentLang(lang) {
    return {
        type: actionTypes.SET_CURRENT_LANG,
        lang: lang,
    };
}
export function setDefaultProjectLang(lang) {
    return {
        type: actionTypes.SET_DEFAULT_PROJECT_LANG,
        lang: lang,
    };
}
